export default __webpack_public_path__ + "static/media/CAKE.94802ecc.svg";